<template>

    <div>
        <h4 class="mb-6">Multicast Node ports</h4>

        <vs-table id="nodePortsTable" ref="table" pagination :max-items="itemsPerPage" search :data="tableData">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <vs-button v-if="workerId !== 0" color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addPortPrompt = true">Add</vs-button>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=250">
                            <span>250</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=500">
                            <span>500</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=1000">
                            <span>1000</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th v-if="workerId !== 0" sort-key="multicast_node_name">Multicast Node name</vs-th>
                <vs-th v-else sort-key="worker_name">Worker name</vs-th>
                <vs-th sort-key="interface_name">Interface name</vs-th>
                <vs-th></vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td v-if="workerId !== 0" :data="data[index].multicast_node_name">
                            {{ data[index].multicast_node_name }}
                        </vs-td>

                        <vs-td v-else :data="data[index].worker_name">
                            {{ data[index].worker_name }}
                        </vs-td>

                        <vs-td :data="data[index].interface_name">
                            {{ data[index].interface_name }}
                        </vs-td>

                        <vs-td>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-edit" color="warning" class="md:mb-0 mr-3 mb-1" @click="openPortEdit(data[index])"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-trash-2" color="danger" class="md:mb-0 mr-3 mb-1" @click="removePort(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup title="Add Multicast Node port" :active.sync="addPortPrompt">
            <div id="addPortDiv" class="vs-con-loading__container" >
                <p class="mt-6">Interface name</p>
                <vs-input v-model="addObject['interface_name']" class="w-full"></vs-input>
                <p class="mt-6">Multicast node</p>
                <vs-select autocomplete class="w-full" v-model="addObject['multicast_node_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in nodes" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addPort">Add</vs-button>
            </div>
        </vs-popup>

        <vs-popup title="Edit Multicast Node port" :active.sync="editPortPrompt">
            <div id="editPortDiv" class="vs-con-loading__container" >
                <p class="mt-6">Interface name</p>
                <vs-input v-model="editObject['interface_name']" class="w-full"></vs-input>
                <p class="mt-6">Multicast node</p>
                <vs-select autocomplete class="w-full" v-model="editObject['multicast_node_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in nodes" />
                </vs-select>
                <vs-divider/>
                <vs-button color="warning" class="mt-6; mr-1" @click="editPort">Save</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {
        props: {
            nodeId: {
                type: Number,
                required: false,
                default: 0
            },
            workerId: {
                type: Number,
                required: false,
                default: 0
            }
        },
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                ports: [],
                nodes: [],

                addPortPrompt: false,
                addObject: {},

                editPortPrompt: false,
                editObject: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#nodePortsTable',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get((this.workerId === 0) ? '/api/management/v1/multicast_node/' + this.nodeId + '/port' : '/api/management/v1/worker/' + this.workerId + '/multicast_node/ports')
                loadPromise.then(function(response) {
                    thisIns.ports = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const nodesPromise = this.$http.get('/api/management/v1/multicast_node/')
                nodesPromise.then(function(response) {
                    thisIns.nodes = response.data
                    if (thisIns.nodes.length > 0) {
                        thisIns.addObject.multicast_node_id = thisIns.nodes[0].id
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, nodesPromise]).finally(function() {
                    thisIns.$vs.loading.close('#nodePortsTable > .con-vs-loading')
                })
            },
            addPort() {
                this.$vs.loading({
                    container: '#addPortDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/multicast_node/' + this.addObject.multicast_node_id + '/port', {
                    interface_name: this.addObject.interface_name,
                    worker_id: Number(this.workerId)
                })

                addPromise.then(function() {
                    thisIns.addPortPrompt = false
                    thisIns.$printSuccess('Multicast node port added')
                    thisIns.$nextTick(() => {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addPortDiv > .con-vs-loading')
                })
            },
            openPortEdit(data) {
                this.editObject = data
                this.editPortPrompt = true
            },
            editPort() {
                this.$vs.loading({
                    container: '#editPortDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.put('/api/management/v1/multicast_node/0/port/' + this.editObject.id, {
                    interface_name: this.editObject.interface_name,
                    multicast_node_id: this.editObject.multicast_node_id
                })

                addPromise.then(function() {
                    thisIns.editPortPrompt = false
                    thisIns.$printSuccess('Multicast node port added')
                    thisIns.$nextTick(() => {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#editPortDiv > .con-vs-loading')
                })
            },
            removePort(id) {
                this.$vs.loading({
                    container: '#nodePortsTable',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete('/api/management/v1/multicast_node/0/port/' + id)

                removePromise.then(function() {
                    thisIns.$printSuccess('Multicast node port removed')
                    thisIns.$nextTick(() => {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#nodePortsTable > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                return this.ports
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addPortPrompt) {
                this.addPortPrompt = false
                next(false)
            } else {
                next()
            }
        }

    }

</script>
